<template>
<div style="height: 230px">
  <div class="overlay-success">

  </div>
</div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data: function () {
    return {
      dataLoaded: false
    }
  },
  /* Computed */
  computed: {
    ...mapState({
      loggedInUser: state => state.user.loggedInUser
      // paymentsplan: state => state.payments.financialStatments_plans
    })
  },
  Created () {
    // console.log('isreachedHERE', this.$route)

  },
  async mounted () {
    // this.$store.commit('ISLOADING', true)
    let result = await this.$store.dispatch('PAYPAL_SUCCESS', this.$route.query)
    console.log('isreachedHERE', result)
    if (result.hasOwnProperty('error')) {
      this.$store.commit('ISLOADING', false)
      this.$swal
        .fire({
          title: 'Something Went Wrong',
          showCancelButton: false,
          confirmButtonColor: '#006ac3;',
          text: result.error,
          // text: `$${this.selectedPlan['cost']}`,
          // reverseButtons: true,
          confirmButtonText: 'Ok'
          // cancelButtonText: 'Cancel'
        })
        .then((confirmed) => {
          if (confirmed && confirmed.value) {
            if (this.loggedInUser.counter > 0) {
              this.$router.push({
                path: '/financial-statements'
              })
            } else {
              this.$router.push({
                path: '/checkout'
              })
            }
          }
        })
      // this.$store.commit('ISLOADING', false)
    } else {
      // this.$store.commit('ISLOADING', false)
      try {
        await this.$router.push({
          path: '/transformation-input/FinancialStatements'
        })
      } catch (err) {
        throw new Error(`Problem handling something: ${err}.`)
      }
    }
  },
  methods: {
  }
}
</script>
<style lang="">
  .overlay-success {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(255,255,255,0.6);
    z-index: 1000;
  }
</style>



// WEBPACK FOOTER //
// src/components/payments/PaymentSuccess.vue